// extracted by mini-css-extract-plugin
export default {"affiliationTrackingMain":"AffiliationTracking_affiliationTrackingMain__Cl34R","gridTitle":"AffiliationTracking_gridTitle__dAvsv","card":"AffiliationTracking_card__tOlLp"};